import styled from 'styled-components';

const AlertsWrapper = styled('div')`
  flex-grow: 1;
  .loading {
    display: block;
  }
  .mobile {
    display: none;
  }
  h2 {
    margin: 30px 0;
    font-size: 25px;
    font-weight: 600;
    span {
      color: #18c2d8;
    }
  }
  .alerts-list {
    table {
      .btn {
        &.delete {
          cursor: pointer;
          border: 1px solid rgba(11, 47, 63, 0.4);
          border-radius: 5px;
          color: rgba(11, 47, 63, 0.4);
          font-family: Poppins;
          font-size: 14px;
          font-weight: 500;
          padding: 10px 20px;
          transition: all 0.3s;
          white-space: nowrap;
          &.disabled {
            opacity: 0.5;
          }
          &:hover {
            border: 1px solid rgba(11, 47, 63, 0.8);
            color: rgba(11, 47, 63, 0.8);
          }
          i {
            margin-right: 2px;
          }
        }
      }
      .date {
        color: #595959;
        font-size: 13px;
        img {
          margin-right: 5px;
          vertical-align: text-top;
        }
      }
      .notif {
        &:first-child {
          margin-bottom: 10px;
        }
        .reusecore__switch {
          width: 80%;
          label {
            width: 100%;
            width: 100%;
            display: flex;
            justify-content: space-between;
          }
        }
      }
      .actions {
        a {
          color: #0b2f3f;
          margin-right: 20px;
          display: inline-block;
          font-family: Poppins;
          font-weight: 500;
          cursor: pointer;
          &.delete {
            color: #ff5b60;
          }
          &:last-child {
            margin-right: 0;
          }
        }
        .search {
          border-radius: 4px;
          background-color: #00bcd4;
          color: #fff;
          font-family: Poppins;
          font-size: 12px;
          font-weight: 500;
          text-align: center;
          padding: 10px 20px;
          transition-duration: 0.4s;
          &:hover {
            background-color: rgb(0, 47, 63);
          }
        }
      }
    }
  }
  @media screen and (max-width: 1023px) {
    .alerts-list {
      table {
        .notif {
          .reusecore__field-label {
            font-size: 14px;
          }
        }
        .date {
          img {
            display: none;
          }
        }
        .actions {
          display: flex;
          flex-direction: column;
          a {
            text-align: center;
            margin-right: 0;
            &.search {
              padding: 7px 10px;
            }
            &:first-child {
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1023px) {
    .loading {
      display: none;
    }
    .mobile {
      display: block;
    }
  }
  @media screen and (max-width: 767px) {
  .alerts-list {
    table {
      .date {
        font-weight: bold;
        img {
          display: inline;
        }
      }
      .actions {
        .search {
          font-size: 14px;  
        }
      }
    }
  }
`;

const AlertsTitle = styled('div')`
  .top {
    font-weight: bold;
    font-family: Poppins;
    a {
      color: #0b2f3f;
      font-size: 15px;
    }
    .counter {
      display: inline-block;
      margin-left: 10px;
      height: 24px;
      width: 24px;
      background-color: #ff6359;
      color: #ffffff;
      font-size: 11px;
      border-radius: 20px;
      text-align: center;
      line-height: 23px;
    }
  }
  .bottom {
    margin-top: 10px;
    span {
      margin-right: 30px;
      img {
        margin-right: 5px;
      }
    }
  }
  @media screen and (max-width: 1023px) {
    padding: 0 5px;
    .top {
      position: relative;
      .counter {
        position: absolute;
        top: -20px;
        right: 20px;
        height: 20px;
        width: 20px;
        line-height: 20px;
      }
    }
    .bottom {
      margin-top: 5px;
    }
  }
  @media screen and (max-width: 767px) {
    .top {
      .counter {
        position: static;
      }
    }
  }
`;

export { AlertsWrapper, AlertsTitle };
